import { ContentData } from "../application";
import { EventBase } from "../common";

export class GlobalAlertNotificationEvent extends EventBase<ContentData> {
  constructor(alert: ContentData) {
    super();
    this.args = alert;
  }
}
